import { render } from "./BedRateRunCharts.vue?vue&type=template&id=cbf2dab8&scoped=true"
import script from "./BedRateRunCharts.vue?vue&type=script&lang=js"
export * from "./BedRateRunCharts.vue?vue&type=script&lang=js"

import "./BedRateRunCharts.vue?vue&type=style&index=0&id=cbf2dab8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf2dab8"]])

export default __exports__